export function getFirstCalendarDay(date){
  return date.clone().startOf('month').startOf('isoWeek')
}

export function getLastCalendarDay(date){
  return date.clone().endOf('month').endOf('isoWeek')
}

export function getCalendarMonth(date){
  let calendar = []
  const startDay = date.clone().startOf('month').startOf('isoWeek')
  const endDay = date.clone().endOf('month').endOf('isoWeek')

  let d = startDay.clone().subtract(1, 'day')

  while (d.isBefore(endDay, 'day')) {
      calendar.push({
          days: Array(7).fill(0).map(() => d.add(1, 'day').clone())
      })
  }

  // Add 2 rows in februari
  if(calendar.length === 4){
    let ed = startDay.clone().subtract(1, 'day').subtract(1, 'week')
    calendar.unshift({
        days: Array(7).fill(0).map(() => ed.add(1, 'day').clone())
    })
    calendar.push({
      days: Array(7).fill(0).map(() => d.add(1, 'day').clone())
    })
  }

  // Add 1 row if calendar doesn't
  if(calendar.length === 5){
    let ed = startDay.clone().subtract(1, 'day').subtract(1, 'week')
    calendar.unshift({
      days: Array(7).fill(0).map(() => ed.add(1, 'day').clone())
    })
  }


  return calendar
}



// WEBPACK FOOTER //
// ./src/js/helpers/calendarHelper.js